import { Component, Input } from '@angular/core';
import { FilterToken, ShoppingDataInitialLoad, ShoppingFilterItem } from '@models/shopping.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { FilterStateService } from '@services/filter-state/filter-state.service';

@Component({
  selector: 'ts-filter-tokens',
  templateUrl: './filter-tokens.component.html',
  imports: [TranslationPipe]
})
export class FilterTokensComponent {
  @Input() filter_tokens: FilterToken[];
  @Input() is_mobile: boolean = false;

  constructor(private filter_state_svc: FilterStateService) {}

  ngOnInit(): void {}

  removeFilter(item: FilterToken): void {
    const filtersParam: ShoppingDataInitialLoad = this.filter_state_svc.filtersParam;

    filtersParam.filters = filtersParam.filters.filter((option: ShoppingFilterItem) => {
      if (item.value === 'Unknown') return option.id != item.id;
      else return option.value !== item.value;
    });

    this.filter_state_svc.filtersParam = filtersParam;
  }

  clearFilters(): void {
    const filtersParam: ShoppingDataInitialLoad & {
      countryId: number;
    } = this.filter_state_svc.filtersParam;

    filtersParam.filters = [];

    this.filter_state_svc.filtersParam = filtersParam;
  }
}
